<!--
 * @Description: 页面跳转选择组件
 * @Autor: WangYuan
 * @Date: 2021-08-12 11:06:37
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 19:38:10
-->

<template>
  <div
    v-show="isShow"
    :class="{ pt10: padd.includes('top'), pb10: padd.includes('bottom') }"
    class="flex pl10 pr10 bg-white col-center"
  >
    <div class="f13 f-grey jump_label lh-28">{{ label }}</div>

    <div style="flex: 1">
      <!-- 选择跳转到的页面 -->
      <div
        v-if="!mValue.id"
        :style="'float:' + place"
        class="flex col-center h32"
      >
        <div class="f14 jump-button" @click="open">选择跳转到的页面</div>
      </div>

      <!-- 修改 -->
      <div
        v-else
        :style="'float:' + place"
        class="flex col-center h32"
        @click="open"
      >
        <div class="tag">{{ pageName }}</div>
        <div class="f14 jump-button">修改</div>
      </div>
    </div>

    <jump-dialog-view
      ref="jump"
      :linkList="linkList"
      @success="getPageName"
    ></jump-dialog-view>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import { mapGetters } from "vuex";
import JumpDialogView from "@/custom-schema-template/components/SchemaJump/JumpDialog";
import { getDatasourceList } from "../../../api/easyApp";

export default {
  name: "SchemaJump",
  components: { JumpDialogView },
  mixins: [schemaMixin],

  provide() {
    return {
      value: this.value,
    };
  },

  data() {
    return {
      linkList: [], //跳转链接
    };
  },

  props: {
    value: {
      default: () => ({}),
    },
    place: {
      default: () => ({}),
    },
    padd: {
      default: "left,right,top,bottom",
    },
    isShow: {
      default: true,
    },
  },

  watch: {
    mValue: {
      immediate: true,
      deep: true,
      handler(newValue) {},
    },
  },
  computed: {
    ...mapGetters(["project", "fixedPages"]),
    pageName() {
      let page = null;

      switch (this.mValue.type) {
        case "insid":
          page = { name: this.mValue.data?.name };
          break;

        case "applet":
          page = {
            name: this.mValue.mode == "1" ? "跳转小程序" : "微信半屏小程序",
          };
          break;

        case "link":
          page = { name: this.mValue.mode == "2" ? "外链app" : "外链h5" };
          break;
        default:
          break;
      }
      return page.name;
    },
  },

  methods: {
    // 打开
    async open() {
      console.log("===SchemaJump open=== START ====");
      let res = await getDatasourceList({ tags: "linkList" });
      this.linkList = res.data;
      console.log("===SchemaJump open=== mValue before passing:", JSON.stringify(this.mValue));
      console.log("===SchemaJump open=== mValue.initParams:", JSON.stringify(this.mValue.initParams));
      this.$refs.jump.open(this.mValue);
      console.log("===SchemaJump open=== END ====");
    },

    getPageName(val) {
      console.log("===SchemaJump getPageName=== START ====");
      console.log("===SchemaJump getPageName=== received val:", JSON.stringify(val));
      console.log("===SchemaJump getPageName=== received val.initParams:", JSON.stringify(val.initParams));
      this.mValue = val;
      console.log("===SchemaJump getPageName=== mValue after:", JSON.stringify(this.mValue));
      this.$forceUpdate();
      console.log("===SchemaJump getPageName=== END ====");
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  background: rgb(236, 245, 255);
  color: rgb(64, 158, 255);
  border: 1px solid;
  max-width: 90px;
  font-size: 12px;
  padding: 5px 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 3px;
  margin-right: 10px;
}

.jump-button {
  border-radius: 3px;
  background: #409eff;
  color: white;
  padding: 4px 7px;
  text-align: center;
}

.jump_label {
  width: 80px;
}
</style>
